import React from "react";
import {Lot} from "@nextlot/core/webcast/data/data_types_definitions";

export default function EmbeddedViewerLotDetailsCmp(props) {

    const lot: Lot = props.lot;

    if (!lot) {
        return null;
    }

    let lotImage;
    if (lot.images && lot.images.length > 0) {
        lotImage = lot.images[0].mdUrl;
    } else {
        lotImage = ''
    }

    return (
        <>
            <div className="image-container">
                <img src={lotImage}/>
                <h2>{lot.name}</h2>
            </div>
        </>
    );
}


// import * as React from "react";
// import type {Lot} from "@nextlot/bidding-jsclient-core/lib/data/data_types_definitions";
// import {TaggedLogger} from "@nextlot/bidding-jsclient-core";
//
//
// type CmpPropsType = {
//     lot: Lot,
//
// }
//
// const _logger = TaggedLogger.get('EmbeddedViewerLotDetailsCmp');
//
//
// export default class EmbeddedViewerLotDetailsCmp extends React.PureComponent<CmpPropsType> {
//     constructor(props) {
//         super(props);
//     }
//
//     render() {
//         if (!this.props.lot) {
//             return null;
//         }
//
//         const lot: Lot = this.props.lot;
//         let lotImage;
//
//         if (lot.images && lot.images.length > 0) {
//             lotImage = lot.images[0].mdUrl;
//         } else {
//             lotImage = ''
//         }
//
//         return (
//             <div className="image-container">
//                 <img src={lotImage}/>
//                 <h2>{lot.name}</h2>
//             </div>
//         );
//     }
// }
